import * as ListCommands from "prosemirror-schema-list";
import { NodeType } from "prosemirror-model";
import { Command, EditorState, Transaction } from "prosemirror-state";
import { NodeKeys } from "./Schema";

function listCommandFactory(nodeName: NodeKeys, factory: (nodeType: NodeType) => Command) {
	return function commandWrapper(state: EditorState, dispatch?: (tx: Transaction) => void) {
		return factory(state.schema.nodes[nodeName])(state, dispatch);
	};
}

export const splitListItem = listCommandFactory("list_item", ListCommands.splitListItem);
export const wrapInOrderedList = listCommandFactory("ordered_list", ListCommands.wrapInList);
export const wrapInBulletedList = listCommandFactory("unordered_list", ListCommands.wrapInList);
export const sinkListItem = listCommandFactory("list_item", ListCommands.sinkListItem);
export const liftListItem = listCommandFactory("list_item", ListCommands.liftListItem);

type ListKeys = "ordered_list" | "unordered_list";
function changeListTypeFactory(targetNodeType: ListKeys) {
	return function changeListType(state: EditorState, dispatch?: (tx: Transaction) => void) {
		// When in a list, toggle the current list to a different list type
		// We want to only toggle the deepest lists that cover the current selection; this traversal gets that.
		type ListCandidate = { type: ListKeys; pos: number };
		const candidates = Array<ListCandidate>();
		let currentList: ListCandidate | undefined;
		state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos) => {
			if (node.type.name === "ordered_list" || node.type.name === "unordered_list") {
				currentList = { type: node.type.name, pos };
				return true;
			} else if (node.type === state.schema.nodes.list_item) {
				return true;
			} else if (
				currentList &&
				(candidates.length === 0 ||
					candidates[candidates.length - 1].pos !== currentList.pos) &&
				node.type === state.schema.nodes.paragraph
			) {
				candidates.push(currentList);
			}
			return false;
		});

		const workToDo = candidates.some(c => c.type !== targetNodeType);
		if (workToDo && dispatch) {
			const { tr } = state;
			for (const c of candidates) {
				if (c.type !== targetNodeType) {
					tr.setNodeMarkup(c.pos, state.schema.nodes[targetNodeType]);
				}
			}
			dispatch(tr);
		}
		return workToDo;
	};
}

export const convertToBulletedList = changeListTypeFactory("unordered_list");
export const convertToOrderedList = changeListTypeFactory("ordered_list");
